import React, { ReactNode } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

export const TooltipProvider = TooltipPrimitive.Provider;

interface TooltipProps {
  /** Tooltip text (or custom node). */
  content: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  sideOffset?: number;
  /** Render the tooltip only when true (avoids wrapper churn at call sites). */
  enabled?: boolean;
  children: ReactNode;
}

/**
 * Radix tooltip with the admin's dark pill styling. Callers must be inside a
 * TooltipProvider (mount one per surface, e.g. the sidebar root).
 */
export const Tooltip: React.FC<TooltipProps> = ({
  content,
  side = 'right',
  sideOffset = 8,
  enabled = true,
  children,
}) => {
  if (!enabled) return <>{children}</>;
  return (
    <TooltipPrimitive.Root delayDuration={150}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={sideOffset}
          className="z-[9999] rounded-8 bg-tenant px-sm py-[6px] text-[13px] font-medium text-white shadow-2 select-none"
        >
          {content}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
};
